import { Box, CardMedia, Stack, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import Header from "../../Header/Header";
import Footer from "../../Footer/Footer";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import Img1 from "./Icon/term1.jpeg";
import Img2 from "./Icon/term2.jpeg";
import Img3 from "./Icon/term3.jpeg";
import CertificateCard from "../CertificateCard/CertificateCard";
import { useLocation } from "react-router-dom";
import blogData from "./BlogData";
import { FaRegUserCircle } from "react-icons/fa";
import DynamicTable from "./DynamicTable";
const BlogContentPage = () => {
  const location = useLocation();
  const index = location.state?.index;
  const [blogs, setBlogs] = useState([]);
  // Scroll to top when the component is mounted
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    setBlogs(blogData);
  }, [blogData]);
  console.log("index:", index, blogs[index]?.title);
  return (
    <>
      <Header />
      <main>
        <Stack
          sx={{
            height: "auto",
            display: "flex",
            flexDirection: { xl: "row" },
            justifyContent: "center",
            // border: "1px solid blue",
            marginBottom: "32px",
          }}
        >
          <Stack sx={{ width: { xl: "70%" } }}>
            {/* Header Section */}

            <Stack
              sx={{
                marginTop: "20px",
                // border: "1px solid blue",
                height: { xl: "14%" },
                dispaly: "flex",
                flexDirection: { xl: "column" },
              }}
            >
              <Stack
                sx={{
                  // border: "2px solid red",
                  height: { xl: "60%" },
                  dispaly: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Typography
                  sx={{
                    fontSize: { xl: "40px" },
                    fontFamily:
                      "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                    fontWeight: 600,
                  }}
                >
                  Blog
                </Typography>
              </Stack>
              <Stack
                sx={{
                  dispaly: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "center",
                  // border: "1px solid red",
                }}
              >
                <Stack
                  sx={{
                    dispaly: "flex",
                    flexDirection: {
                      xl: "row",
                      lg: "row",
                      md: "row",
                      sm: "row",
                      xs: "column",
                    },
                    alignItems: "center",
                    justifyContent: "space-between",
                    // border: "2px solid red",
                    width: {
                      xl: "40%",
                      lg: "50%",
                      md: "50%",
                      sm: "50%",
                      xs: "100%",
                    },
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: { xl: "12px", xs: "12px" },
                      fontFamily:
                        "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      fontWeight: 400,
                    }}
                  >
                    Effective Date: August 3rd, 2021
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: { xl: "12px", xs: "12px" },
                      fontFamily:
                        "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      fontWeight: 400,
                    }}
                  >
                    Last Updated on: January 1st, 2025
                  </Typography>
                </Stack>
              </Stack>
              <Stack
                sx={{
                  // border: "2px solid blue",
                  height: { xl: "30%" },
                  dispaly: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <Breadcrumbs
                  aria-label="breadcrumb"
                  sx={{ marginLeft: "12px" }}
                >
                  <Link
                    underline="hover"
                    color="inherit"
                    href="/"
                    sx={{
                      fontFamily:
                        "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      fontWeight: 600,
                    }}
                  >
                    Home
                  </Link>
                  <Link underline="none" color="inherit">
                    Solical commerce
                  </Link>
                </Breadcrumbs>
              </Stack>
            </Stack>

            {/* Cotent Section */}

            <Stack
              sx={{
                marginTop: "60px",
                // border: "3px solid green",
                dispaly: "flex",
                flexDirection: {
                  xl: "row",
                  lg: "row",
                  md: "row",
                  sm: "row",
                  xs: "column",
                },
                justifyContent: "space-between",
              }}
            >
              {/* Blog Information */}
              <Stack
                sx={{
                  width: { xl: "70%", lg: "70%", md: "70%", sm: "70%" },
                  // border: "1px solid blue",
                  border: "1px solid #d1d1d1",
                  borderRadius: "8px",
                  padding: "16px",
                  backgroundColor: "#fff",
                  boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                  color: "#333",
                  lineHeight: "1.6",
                  fontFamily: "Arial, sans-serif",
                  fontSize: "14px",
                  overflow: "hidden",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                {/* title */}
                <Stack
                  sx={{
                    fontSize: "24px",
                    fontWeight: 600,
                    lineHeight: "32px",
                    fontFamily: "'Roboto', sans-serif",
                    color: "black",
                  }}
                >
                  {blogs[index]?.title}
                </Stack>
                {/* 5 min  reading time */}
                <Stack
                  sx={{
                    border: "1px solid #dae9f8",
                    backgroundColor: "#dae9f8",
                    padding: "4px",
                    borderRadius: "8px",
                    width: { xs: "70%", sm: "20%" },
                    fontSize: "20px",
                    fontWeight: 400,
                    lineHeight: "28px",
                    fontFamily: "'Roboto', sans-serif",
                    color: "black",
                    marginTop: "16px",
                  }}
                >
                  {" "}
                  Read time 5 min
                </Stack>
                {/* vertex suite posted*/}
                <Stack
                  direction="row"
                  spacing={1}
                  alignItems="center"
                  sx={{
                    padding: "4px",
                    fontSize: "16px",
                    fontWeight: 400,
                    lineHeight: "24px",
                    fontFamily: "'Roboto', sans-serif",
                    color: "gray",
                  }}
                >
                  <Typography>posted by</Typography>
                  <FaRegUserCircle />
                  <Typography>vertex suite</Typography>
                </Stack>
                {/* blog image*/}
                <Stack
                  sx={{ marginTop: "16px", height: "40vh", width: "100%" }}
                >
                  <CardMedia
                    component="img"
                    height="100%"
                    width="100%"
                    image={blogs[index]?.img}
                    alt="img"
                    sx={{ objectFit: "cover" }}
                  />
                </Stack>
                {/* blog image desc1*/}
                <Stack
                  direction="row"
                  spacing={1}
                  alignItems="center"
                  sx={{
                    // padding: "4px",
                    fontSize: "16px",
                    fontWeight: 400,
                    lineHeight: "24px",
                    fontFamily: "'Roboto', sans-serif",
                    color: "black",
                    marginTop: "16px",
                  }}
                >
                  {blogs[index]?.desc1}
                </Stack>
                {/* blog image desc2*/}
                <Stack
                  direction="row"
                  spacing={1}
                  alignItems="center"
                  sx={{
                    // padding: "4px",
                    fontSize: "16px",
                    fontWeight: 400,
                    lineHeight: "24px",
                    fontFamily: "'Roboto', sans-serif",
                    color: "black",
                    marginTop: "16px",
                  }}
                >
                  {blogs[index]?.desc2}
                </Stack>
                {/* heading first title*/}
                {blogs[index]?.head1 && (
                  <Stack
                    sx={{
                      fontSize: "24px",
                      fontWeight: 600,
                      lineHeight: "32px",
                      fontFamily: "'Roboto', sans-serif",
                      color: "black",
                      marginTop: "16px",
                    }}
                  >
                    {blogs[index]?.head1}
                  </Stack>
                )}
                {/* heading first desc1*/}

                {blogs[index]?.head1Desc1 && (
                  <Stack
                    direction="row"
                    spacing={1}
                    alignItems="center"
                    sx={{
                      // padding: "4px",
                      fontSize: "16px",
                      fontWeight: 400,
                      lineHeight: "24px",
                      fontFamily: "'Roboto', sans-serif",
                      color: "black",
                      marginTop: "16px",
                    }}
                  >
                    {blogs[index]?.head1Desc1}
                  </Stack>
                )}

                {/* heading second desc2*/}

                {blogs[index]?.head1Desc2 && (
                  <Stack
                    direction="row"
                    spacing={1}
                    alignItems="center"
                    sx={{
                      // padding: "4px",
                      fontSize: "16px",
                      fontWeight: 400,
                      lineHeight: "24px",
                      fontFamily: "'Roboto', sans-serif",
                      color: "black",
                      marginTop: "16px",
                    }}
                  >
                    {blogs[index]?.head1Desc2}
                  </Stack>
                )}

                {/* heading third desc3*/}

                {blogs[index]?.head1Desc3 && (
                  <Stack
                    direction="row"
                    spacing={1}
                    alignItems="center"
                    sx={{
                      // padding: "4px",
                      fontSize: "16px",
                      fontWeight: 400,
                      lineHeight: "24px",
                      fontFamily: "'Roboto', sans-serif",
                      color: "black",
                      marginTop: "16px",
                    }}
                  >
                    {blogs[index]?.head1Desc3}
                  </Stack>
                )}

                {/* heading first points*/}
                {Array.isArray(blogs[index]?.head1Point) &&
                  blogs[index].head1Point.length > 0 && (
                    <Stack
                      spacing={1}
                      sx={{
                        padding: "12px",
                        fontSize: "16px",
                        fontWeight: 400,
                        lineHeight: "24px",
                        fontFamily: "'Roboto', sans-serif",
                        color: "black",
                        marginTop: "16px",
                        width: "100%",
                      }}
                    >
                      {blogs[index].head1Point.map((point, i) => (
                        <Stack
                          key={i}
                          direction="row"
                          alignItems="flex-start"
                          spacing={1}
                          sx={{
                            fontSize: "16px",
                            color: "#4B4B4B",
                          }}
                        >
                          <Box
                            component="span"
                            sx={{
                              fontSize: "24px",
                              lineHeight: "24px",
                              paddingTop: "2px",
                            }}
                          >
                            •
                          </Box>
                          <Typography
                            sx={{
                              fontSize: "16px",
                              fontFamily: "'Roboto', sans-serif",
                              lineHeight: "24px",
                            }}
                          >
                            {point}
                          </Typography>
                        </Stack>
                      ))}
                    </Stack>
                  )}

                {/* heading first images1*/}
                {blogs[index]?.head1Img1 && (
                  <Stack
                    sx={{ marginTop: "16px", height: "30vh", width: "100%" }}
                  >
                    <CardMedia
                      component="img"
                      height="100%"
                      width="100%"
                      image={blogs[index].head1Img1}
                      alt="img"
                      sx={{ objectFit: "contain" }}
                    />
                  </Stack>
                )}

                {/* heading first images2*/}
                {blogs[index]?.head1Img2 && (
                  <Stack
                    sx={{ marginTop: "16px", height: "30vh", width: "100%" }}
                  >
                    <CardMedia
                      component="img"
                      height="100%"
                      width="100%"
                      image={blogs[index].head1Img2}
                      alt="img"
                      sx={{ objectFit: "contain" }}
                    />
                  </Stack>
                )}

                {/* heading first table*/}
                {Array.isArray(blogs[index]?.head1Table) &&
                  blogs[index].head1Table.length > 0 && (
                    <Stack sx={{ marginTop: "16px" }}>
                      <DynamicTable data={blogs[index].head1Table} />
                    </Stack>
                  )}

                {/* heading second title*/}
                {blogs[index]?.head2 && (
                  <Stack
                    sx={{
                      fontSize: "24px",
                      fontWeight: 600,
                      lineHeight: "32px",
                      fontFamily: "'Roboto', sans-serif",
                      color: "black",
                      marginTop: "16px",
                    }}
                  >
                    {blogs[index]?.head2}
                  </Stack>
                )}
                {/* heading second desc1*/}

                {blogs[index]?.head2Desc1 && (
                  <Stack
                    direction="row"
                    spacing={1}
                    alignItems="center"
                    sx={{
                      // padding: "4px",
                      fontSize: "16px",
                      fontWeight: 400,
                      lineHeight: "24px",
                      fontFamily: "'Roboto', sans-serif",
                      color: "black",
                      marginTop: "16px",
                    }}
                  >
                    {blogs[index]?.head2Desc1}
                  </Stack>
                )}

                {/* heading second desc2*/}

                {blogs[index]?.head2Desc2 && (
                  <Stack
                    direction="row"
                    spacing={1}
                    alignItems="center"
                    sx={{
                      // padding: "4px",
                      fontSize: "16px",
                      fontWeight: 400,
                      lineHeight: "24px",
                      fontFamily: "'Roboto', sans-serif",
                      color: "black",
                      marginTop: "16px",
                    }}
                  >
                    {blogs[index]?.head2Desc2}
                  </Stack>
                )}

                {/* heading third desc3*/}

                {blogs[index]?.head2Desc3 && (
                  <Stack
                    direction="row"
                    spacing={1}
                    alignItems="center"
                    sx={{
                      // padding: "4px",
                      fontSize: "16px",
                      fontWeight: 400,
                      lineHeight: "24px",
                      fontFamily: "'Roboto', sans-serif",
                      color: "black",
                      marginTop: "16px",
                    }}
                  >
                    {blogs[index]?.head2Desc3}
                  </Stack>
                )}

                {/* heading 2 points*/}
                {Array.isArray(blogs[index]?.head2Point) &&
                  blogs[index].head1Point.length > 0 && (
                    <Stack
                      spacing={1}
                      sx={{
                        padding: "12px",
                        fontSize: "16px",
                        fontWeight: 400,
                        lineHeight: "24px",
                        fontFamily: "'Roboto', sans-serif",
                        color: "black",
                        marginTop: "16px",
                        width: "100%",
                      }}
                    >
                      {blogs[index].head2Point.map((point, i) => (
                        <Stack
                          key={i}
                          direction="row"
                          alignItems="flex-start"
                          spacing={1}
                          sx={{
                            fontSize: "16px",
                            color: "#4B4B4B",
                          }}
                        >
                          <Box
                            component="span"
                            sx={{
                              fontSize: "24px",
                              lineHeight: "24px",
                              paddingTop: "2px",
                            }}
                          >
                            •
                          </Box>
                          <Typography
                            sx={{
                              fontSize: "16px",
                              fontFamily: "'Roboto', sans-serif",
                              lineHeight: "24px",
                            }}
                          >
                            {point}
                          </Typography>
                        </Stack>
                      ))}
                    </Stack>
                  )}

                {/* heading 2 images1*/}
                {blogs[index]?.head2Img1 && (
                  <Stack
                    sx={{ marginTop: "16px", height: "30vh", width: "100%" }}
                  >
                    <CardMedia
                      component="img"
                      height="100%"
                      width="100%"
                      image={blogs[index].head2Img1}
                      alt="img"
                      sx={{ objectFit: "contain" }}
                    />
                  </Stack>
                )}

                {/* heading second images2*/}
                {blogs[index]?.head2Img2 && (
                  <Stack
                    sx={{ marginTop: "16px", height: "30vh", width: "100%" }}
                  >
                    <CardMedia
                      component="img"
                      height="100%"
                      width="100%"
                      image={blogs[index].head2Img2}
                      alt="img"
                      sx={{ objectFit: "contain" }}
                    />
                  </Stack>
                )}

                {/* heading second table*/}
                {Array.isArray(blogs[index]?.head2Table) &&
                  blogs[index].head1Table.length > 0 && (
                    <Stack sx={{ marginTop: "16px" }}>
                      <DynamicTable data={blogs[index].head2Table} />
                    </Stack>
                  )}

                {/* heading 3 title*/}
                {blogs[index]?.head3 && (
                  <Stack
                    sx={{
                      fontSize: "24px",
                      fontWeight: 600,
                      lineHeight: "32px",
                      fontFamily: "'Roboto', sans-serif",
                      color: "black",
                      marginTop: "16px",
                    }}
                  >
                    {blogs[index]?.head3}
                  </Stack>
                )}
                {/* heading 3 desc1*/}

                {blogs[index]?.head3Desc1 && (
                  <Stack
                    direction="row"
                    spacing={1}
                    alignItems="center"
                    sx={{
                      // padding: "4px",
                      fontSize: "16px",
                      fontWeight: 400,
                      lineHeight: "24px",
                      fontFamily: "'Roboto', sans-serif",
                      color: "black",
                      marginTop: "16px",
                    }}
                  >
                    {blogs[index]?.head3Desc1}
                  </Stack>
                )}

                {/* heading 3 desc2*/}

                {blogs[index]?.head3Desc2 && (
                  <Stack
                    direction="row"
                    spacing={1}
                    alignItems="center"
                    sx={{
                      // padding: "4px",
                      fontSize: "16px",
                      fontWeight: 400,
                      lineHeight: "24px",
                      fontFamily: "'Roboto', sans-serif",
                      color: "black",
                      marginTop: "16px",
                    }}
                  >
                    {blogs[index]?.head3Desc2}
                  </Stack>
                )}

                {/* heading 3 desc3*/}

                {blogs[index]?.head3Desc3 && (
                  <Stack
                    direction="row"
                    spacing={1}
                    alignItems="center"
                    sx={{
                      // padding: "4px",
                      fontSize: "16px",
                      fontWeight: 400,
                      lineHeight: "24px",
                      fontFamily: "'Roboto', sans-serif",
                      color: "black",
                      marginTop: "16px",
                    }}
                  >
                    {blogs[index]?.head3Desc3}
                  </Stack>
                )}

                {/* heading 3 points*/}
                {Array.isArray(blogs[index]?.head3Point) &&
                  blogs[index].head1Point.length > 0 && (
                    <Stack
                      spacing={1}
                      sx={{
                        padding: "12px",
                        fontSize: "16px",
                        fontWeight: 400,
                        lineHeight: "24px",
                        fontFamily: "'Roboto', sans-serif",
                        color: "black",
                        marginTop: "16px",
                        width: "100%",
                      }}
                    >
                      {blogs[index].head3Point.map((point, i) => (
                        <Stack
                          key={i}
                          direction="row"
                          alignItems="flex-start"
                          spacing={1}
                          sx={{
                            fontSize: "16px",
                            color: "#4B4B4B",
                          }}
                        >
                          <Box
                            component="span"
                            sx={{
                              fontSize: "24px",
                              lineHeight: "24px",
                              paddingTop: "2px",
                            }}
                          >
                            •
                          </Box>
                          <Typography
                            sx={{
                              fontSize: "16px",
                              fontFamily: "'Roboto', sans-serif",
                              lineHeight: "24px",
                            }}
                          >
                            {point}
                          </Typography>
                        </Stack>
                      ))}
                    </Stack>
                  )}

                {/* heading 3 images1*/}
                {blogs[index]?.head3Img1 && (
                  <Stack
                    sx={{ marginTop: "16px", height: "30vh", width: "100%" }}
                  >
                    <CardMedia
                      component="img"
                      height="100%"
                      width="100%"
                      image={blogs[index].head3Img1}
                      alt="img"
                      sx={{ objectFit: "contain" }}
                    />
                  </Stack>
                )}

                {/* heading 3 images2*/}
                {blogs[index]?.head3Img2 && (
                  <Stack
                    sx={{ marginTop: "16px", height: "30vh", width: "100%" }}
                  >
                    <CardMedia
                      component="img"
                      height="100%"
                      width="100%"
                      image={blogs[index].head3Img2}
                      alt="img"
                      sx={{ objectFit: "contain" }}
                    />
                  </Stack>
                )}

                {/* heading 3 table*/}
                {Array.isArray(blogs[index]?.head3Table) &&
                  blogs[index].head1Table.length > 0 && (
                    <Stack sx={{ marginTop: "16px" }}>
                      <DynamicTable data={blogs[index].head3Table} />
                    </Stack>
                  )}

                {/* heading 4 title*/}
                {blogs[index]?.head4 && (
                  <Stack
                    sx={{
                      fontSize: "24px",
                      fontWeight: 600,
                      lineHeight: "32px",
                      fontFamily: "'Roboto', sans-serif",
                      color: "black",
                      marginTop: "16px",
                    }}
                  >
                    {blogs[index]?.head4}
                  </Stack>
                )}
                {/* heading 4 desc1*/}

                {blogs[index]?.head4Desc1 && (
                  <Stack
                    direction="row"
                    spacing={1}
                    alignItems="center"
                    sx={{
                      // padding: "4px",
                      fontSize: "16px",
                      fontWeight: 400,
                      lineHeight: "24px",
                      fontFamily: "'Roboto', sans-serif",
                      color: "black",
                      marginTop: "16px",
                    }}
                  >
                    {blogs[index]?.head4Desc1}
                  </Stack>
                )}

                {/* heading 4 desc2*/}

                {blogs[index]?.head4Desc2 &&
                /<\/?[a-z][\s\S]*>/i.test(blogs[index].head4Desc2) ? (
                  <Stack
                    direction="column"
                    spacing={1}
                    alignItems="flex-start"
                    sx={{
                      fontSize: "16px",
                      fontWeight: 400,
                      lineHeight: "24px",
                      fontFamily: "'Roboto', sans-serif",
                      color: "black",
                      marginTop: "16px",
                    }}
                    dangerouslySetInnerHTML={{
                      __html: blogs[index].head4Desc2,
                    }}
                  />
                ) : (
                  <Stack
                    direction="column"
                    spacing={1}
                    alignItems="flex-start"
                    sx={{
                      fontSize: "16px",
                      fontWeight: 400,
                      lineHeight: "24px",
                      fontFamily: "'Roboto', sans-serif",
                      color: "black",
                      marginTop: "16px",
                    }}
                  >
                    {blogs[index]?.head4Desc2}
                  </Stack>
                )}

                {/* heading 4 desc3*/}

                {blogs[index]?.head4Desc3 && (
                  <Stack
                    direction="row"
                    spacing={1}
                    alignItems="center"
                    sx={{
                      // padding: "4px",
                      fontSize: "16px",
                      fontWeight: 400,
                      lineHeight: "24px",
                      fontFamily: "'Roboto', sans-serif",
                      color: "black",
                      marginTop: "16px",
                    }}
                  >
                    {blogs[index]?.head4Desc3}
                  </Stack>
                )}

                {/* heading 4 points*/}
                {Array.isArray(blogs[index]?.head4Point) &&
                  blogs[index].head4Point.length > 0 && (
                    <Stack
                      spacing={1}
                      sx={{
                        padding: "12px",
                        fontSize: "16px",
                        fontWeight: 400,
                        lineHeight: "24px",
                        fontFamily: "'Roboto', sans-serif",
                        color: "black",
                        marginTop: "16px",
                        width: "100%",
                      }}
                    >
                      {blogs[index].head4Point.map((point, i) => (
                        <Stack
                          key={i}
                          direction="row"
                          alignItems="flex-start"
                          spacing={1}
                          sx={{
                            fontSize: "16px",
                            color: "#4B4B4B",
                          }}
                        >
                          <Box
                            component="span"
                            sx={{
                              fontSize: "24px",
                              lineHeight: "24px",
                              paddingTop: "2px",
                            }}
                          >
                            •
                          </Box>
                          <Typography
                            sx={{
                              fontSize: "16px",
                              fontFamily: "'Roboto', sans-serif",
                              lineHeight: "24px",
                            }}
                          >
                            {point}
                          </Typography>
                        </Stack>
                      ))}
                    </Stack>
                  )}

                {/* heading 4 images1*/}
                {blogs[index]?.head4Img1 && (
                  <Stack
                    sx={{ marginTop: "16px", height: "30vh", width: "100%" }}
                  >
                    <CardMedia
                      component="img"
                      height="100%"
                      width="100%"
                      image={blogs[index].head4Img1}
                      alt="img"
                      sx={{ objectFit: "contain" }}
                    />
                  </Stack>
                )}

                {/* heading 4 images2*/}
                {blogs[index]?.head4Img2 && (
                  <Stack
                    sx={{ marginTop: "16px", height: "30vh", width: "100%" }}
                  >
                    <CardMedia
                      component="img"
                      height="100%"
                      width="100%"
                      image={blogs[index].head4Img2}
                      alt="img"
                      sx={{ objectFit: "contain" }}
                    />
                  </Stack>
                )}

                {/* heading 4 table*/}
                {Array.isArray(blogs[index]?.head4Table) &&
                  blogs[index].head1Table.length > 0 && (
                    <Stack sx={{ marginTop: "16px" }}>
                      <DynamicTable data={blogs[index].head4Table} />
                    </Stack>
                  )}
              </Stack>

              {/* Right side content */}
              <Stack
                sx={{
                  width: { xl: "30%", lg: "30%", md: "30%", sm: "30%" },
                  // border: "1px solid red",
                  dispaly: "flex",
                  flexDirection: "column",
                }}
              >
                <Stack
                  sx={{
                    border: "none",
                    width: "100%",
                    padding: "16px",
                    fontFamily: "'Arial', sans-serif",
                    color: "#333",
                    lineHeight: "1.8",
                  }}
                >
                  <h3
                    style={{
                      fontWeight: "bold",
                      fontSize: "18px",
                      marginBottom: "16px",
                      color: "#000",
                      fontFamily:
                        "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                    }}
                  >
                    CATEGORIES
                  </h3>
                  <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                    <li
                      style={{
                        marginBottom: "8px",
                        fontSize: "16px",
                        fontFamily:
                          "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.color = "#0073e6"; // Hover color
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.color = "#333"; // Default color
                      }}
                    >
                      Blog
                    </li>
                    <li
                      style={{
                        marginBottom: "8px",
                        fontSize: "16px",
                        fontFamily:
                          "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.color = "#0073e6"; // Hover color
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.color = "#333"; // Default color
                      }}
                    >
                      Inventory & Order Management
                    </li>
                    <li
                      style={{
                        marginBottom: "8px",
                        fontSize: "16px",
                        fontFamily:
                          "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.color = "#0073e6"; // Hover color
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.color = "#333"; // Default color
                      }}
                    >
                      Multi-Vendor
                    </li>
                    <li
                      style={{
                        marginBottom: "8px",
                        fontSize: "16px",
                        fontFamily:
                          "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.color = "#0073e6"; // Hover color
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.color = "#333"; // Default color
                      }}
                    >
                      Social Commerce
                    </li>
                  </ul>
                  <Stack
                    sx={{
                      borderTop: "1px solid #ddd",
                      marginBottom: "20px",
                      width: { xl: "80%" },
                    }}
                  ></Stack>
                </Stack>
                <Stack
                  sx={{
                    border: "none",
                    width: "300px",
                    padding: "16px",
                    fontFamily: "'Arial', sans-serif",
                    color: "#333",
                    lineHeight: "1.6",
                    backgroundColor: "#fff",
                  }}
                >
                  <h3
                    style={{
                      fontWeight: "bold",
                      fontSize: "18px",
                      marginBottom: "16px",
                      color: "#000",
                      // borderBottom: "1px solid #ddd",
                      fontFamily:
                        "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                    }}
                  >
                    RECENT POSTS
                  </h3>

                  {/* Post 1 */}
                  <Stack
                    direction="row"
                    spacing={2}
                    sx={{
                      borderBottom: "1px solid #ddd",
                      paddingBottom: "16px",
                      marginBottom: "16px",
                    }}
                  >
                    <img
                      src={Img1}
                      alt="Post 1"
                      style={{
                        width: "60px",
                        height: "60px",
                        borderRadius: "4px",
                        objectFit: "cover",
                      }}
                    />
                    <div>
                      <h4
                        style={{
                          fontSize: "16px",
                          margin: "0 0 8px 0",
                          fontWeight: "bold",
                          fontFamily:
                            "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.color = "#0073e6"; // Hover color
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.color = "#333"; // Default color
                        }}
                      >
                        Setup and Operational Costs for WhatsApp Business API:
                        Key Dependencies
                      </h4>
                      <p
                        style={{
                          margin: 0,
                          fontSize: "14px",
                          color: "#777",
                          fontFamily:
                            "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                        }}
                      >
                        November 21, 2024 &nbsp;&nbsp; No Comments
                      </p>
                    </div>
                  </Stack>

                  {/* Post 2 */}
                  <Stack
                    direction="row"
                    spacing={2}
                    sx={{
                      borderBottom: "1px solid #ddd",
                      paddingBottom: "16px",
                      marginBottom: "16px",
                    }}
                  >
                    <img
                      src={Img2}
                      alt="Post 2"
                      style={{
                        width: "60px",
                        height: "60px",
                        borderRadius: "4px",
                        objectFit: "cover",
                      }}
                    />
                    <div>
                      <h4
                        style={{
                          fontSize: "16px",
                          margin: "0 0 8px 0",
                          fontWeight: "bold",
                          fontFamily:
                            "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.color = "#0073e6"; // Hover color
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.color = "#333"; // Default color
                        }}
                      >
                        Why WhatsApp Business API Policies Matter?
                      </h4>
                      <p
                        style={{
                          margin: 0,
                          fontSize: "14px",
                          color: "#777",
                          fontFamily:
                            "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                        }}
                      >
                        November 20, 2024 &nbsp;&nbsp; No Comments
                      </p>
                    </div>
                  </Stack>

                  {/* Post 3 */}
                  <Stack
                    direction="row"
                    spacing={2}
                    sx={{
                      borderBottom: "1px solid #ddd",
                      paddingBottom: "16px",
                      marginBottom: "16px",
                    }}
                  >
                    <img
                      src={Img3}
                      alt="Post 3"
                      style={{
                        width: "60px",
                        height: "60px",
                        borderRadius: "4px",
                        objectFit: "cover",
                      }}
                    />
                    <div>
                      <h4
                        style={{
                          fontSize: "16px",
                          margin: "0 0 8px 0",
                          fontWeight: "bold",
                          fontFamily:
                            "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.color = "#0073e6"; // Hover color
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.color = "#333"; // Default color
                        }}
                      >
                        WhatsApp Business API top features
                      </h4>
                      <p
                        style={{
                          margin: 0,
                          fontSize: "14px",
                          color: "#777",
                          fontFamily:
                            "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                        }}
                      >
                        November 20, 2024 &nbsp;&nbsp; No Comments
                      </p>
                    </div>
                  </Stack>
                </Stack>
                <Stack
                  sx={{
                    width: "100%",
                    padding: "16px",
                    fontFamily: "'Arial', sans-serif",
                    color: "#333",
                  }}
                >
                  <h3
                    style={{
                      fontWeight: "bold",
                      fontSize: "18px",
                      marginBottom: "16px",
                      color: "#000",
                      fontFamily:
                        "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                    }}
                  >
                    OUR INSTAGRAM
                  </h3>
                  <Stack direction="row" spacing={2}>
                    {/* Card 1 */}
                    <div
                      style={{
                        width: "120px",
                        height: "120px",
                        borderRadius: "8px",
                        overflow: "hidden",
                        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                        transition: "background-color 0.3s ease",
                        backgroundColor: "#f7f4e6", // Matching the background of the first card
                        borderBottom: "1px solid #ddd",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.border = "2px solid #ffffff";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.border = "transparent";
                      }}
                    >
                      <img
                        src={Img1}
                        alt="Instagram Post 1"
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                      />
                    </div>

                    {/* Card 2 */}
                    <div
                      style={{
                        width: "120px",
                        height: "120px",
                        borderRadius: "8px",
                        overflow: "hidden",
                        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                        transition: "background-color 0.3s ease",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.border = "2px solid #ffffff";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.border = "transparent";
                      }}
                    >
                      <img
                        src={Img2}
                        alt="Instagram Post 2"
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                      />
                    </div>
                  </Stack>
                </Stack>
                <Stack
                  sx={{
                    width: "300px",
                    padding: "16px",
                    fontFamily: "'Arial', sans-serif",
                    color: "#333",
                    lineHeight: "1.6",
                  }}
                >
                  <Stack
                    sx={{ borderTop: "1px solid #ddd", marginBottom: "60px" }}
                  ></Stack>
                  <h3
                    style={{
                      fontWeight: "bold",
                      fontSize: "18px",
                      marginBottom: "16px",
                      color: "#000",
                    }}
                  >
                    RECENT COMMENTS
                  </h3>
                  <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                    {/* Comment 1 */}

                    <li style={{ marginBottom: "16px" }}>
                      <span style={{ fontSize: "14px", color: "#555" }}>
                        <span style={{ fontWeight: "bold" }}>vinod gupta</span>{" "}
                        on{" "}
                        <a
                          href="#"
                          style={{
                            textDecoration: "none",
                            color: "#0073e6",
                            fontWeight: "normal",
                            fontFamily:
                              "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                          }}
                        >
                          Send 1000 bulk messages on WhatsApp | WhatsApp bulk
                          sender
                        </a>
                      </span>
                    </li>

                    {/* Comment 2 */}
                    <li style={{ marginBottom: "16px" }}>
                      <span style={{ fontSize: "14px", color: "#555" }}>
                        <span
                          style={{
                            fontWeight: "bold",
                            fontFamily:
                              "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                          }}
                        >
                          Top 10 Business Fields Where
                        </span>{" "}
                        on{" "}
                        <a
                          href="#"
                          style={{
                            textDecoration: "none",
                            color: "#0073e6",
                            fontWeight: "normal",
                            fontFamily:
                              "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                          }}
                        >
                          WhatsApp Business API Can Facilitate Growth - Vertex
                          Suite on Tips for Effective Messaging on WhatsApp
                        </a>
                      </span>
                    </li>

                    {/* Comment 3 */}
                    <li style={{ marginBottom: "16px" }}>
                      <span style={{ fontSize: "14px", color: "#555" }}>
                        <span
                          style={{
                            fontWeight: "bold",
                            fontFamily:
                              "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                          }}
                        >
                          Documents Required for
                        </span>{" "}
                        on{" "}
                        <a
                          href="#"
                          style={{
                            textDecoration: "none",
                            color: "#0073e6",
                            fontWeight: "normal",
                            fontFamily:
                              "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                          }}
                        >
                          Integrating WhatsApp Business API into Your Business -
                          Vertex Suite on WhatsApp E-commerce Store
                        </a>
                      </span>
                    </li>
                  </ul>
                </Stack>
              </Stack>
            </Stack>
          </Stack>
        </Stack>
      </main>
      <CertificateCard />
      <Footer />
    </>
  );
};

export default BlogContentPage;
